var Buf = require('buf');


var BufferList = Backbone.Collection.extend({
    model: Buf
});


module.exports = BufferList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/bufferlist.js
// module id = o4N7
// module chunks = 1